/* HBSKN — runtime override messaggio spedizione (multi-mercato)
   Fetcha /skin/shipping-config dal worker. Il worker rileva il country via header CF-IPCountry
   e ritorna resolved_long / resolved_short già adattati al mercato dell'utente.
   Cache 5min in sessionStorage.
*/
(function(){
  var WORKER = 'https://api.hebiskin.com';
  var WORKER_FALLBACK = 'https://crm-api.francesco-be4.workers.dev';
  // Country selezionato sul negozio (Shopify localization, iniettato in theme.liquid).
  // Se presente lo passiamo al worker → soglia/ETA/valuta del mercato giusto, non del geo-IP.
  var CC = '';
  try { CC = String(window.HB_COUNTRY || '').trim().toUpperCase(); } catch(e){}
  var QS = CC ? ('?country=' + encodeURIComponent(CC)) : '';
  var CACHE_KEY = 'hb_shipping_cfg_v3_' + (CC || 'auto'); // cache PER mercato (cambio paese → fetch nuovo)
  var CACHE_TTL_MS = 5 * 60 * 1000;

  function readCache(){
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (Date.now() - c.t > CACHE_TTL_MS) return null;
      return c.cfg;
    } catch(e){ return null; }
  }
  function writeCache(cfg){
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), cfg: cfg })); } catch(e){}
  }

  function applyOverride(cfg){
    if (!cfg) return;
    // Espone window-level SEMPRE e PRIMA di tutto: token.js (€[soglia]/[eta]), barra carrello e quiz
    // dipendono da window.HBSKN_SHIPPING anche su pagine SENZA [data-hb-shipping-line] (es. homepage,
    // barra annuncio, PDP). Senza questo, quelle pagine cadevano sul fallback (soglia 30 + simbolo valuta).
    try { window.HBSKN_SHIPPING = cfg; window.dispatchEvent(new CustomEvent('hb-shipping-ready', { detail: cfg })); } catch(e){}
    var nodes = document.querySelectorAll('[data-hb-shipping-line]');
    if (!nodes.length) return;
    var longMsg = cfg.resolved_long || cfg.resolved_message || '';
    var shortMsg = cfg.resolved_short || '';
    // i18n (7/10/2026): i messaggi del worker sono in italiano. Fuori dall'italiano theme.liquid espone
    // HB_I18N.ship (template del locale con {amount}); in italiano non esiste e qui non cambia nulla.
    // Con una promo attiva si tiene il testo del worker, che la contiene.
    var I = window.HB_I18N && window.HB_I18N.ship;
    var mk = cfg.detected_market, m = I && cfg.markets ? cfg.markets[mk] : null;
    if (I && m && m.threshold_eur != null && !cfg.promo_active && !m.promo_active) {
      var amt = (({ GBP: '£', USD: '$', CHF: 'CHF ' })[m.currency] || '€') + m.threshold_eur;
      var lk = mk === 'EU' ? 'long_eu' : (mk === 'INTL' ? 'long_intl' : 'long');
      if (I[lk]) longMsg = I[lk].replace('{amount}', amt);
      var sk = mk === 'EU' ? 'short_eu' : 'short';
      if (I[sk]) shortMsg = I[sk].replace('{amount}', amt);
    }
    if (!longMsg && !shortMsg) return;
    nodes.forEach(function(el){
      var style = el.getAttribute('data-hb-shipping-style') || 'long';
      var txt = style === 'short' ? (shortMsg || longMsg) : (longMsg || shortMsg);
      if (txt) el.textContent = txt;
    });
  }

  function load(){
    var cached = readCache();
    if (cached){ applyOverride(cached); return; }
    var url = WORKER + '/skin/shipping-config' + QS;
    function tryFallback(){
      fetch(WORKER_FALLBACK + '/skin/shipping-config' + QS, { credentials: 'omit' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(cfg2){ if (cfg2){ writeCache(cfg2); applyOverride(cfg2); } })
        .catch(function(){});
    }
    fetch(url, { credentials: 'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cfg){
        if (cfg){ writeCache(cfg); applyOverride(cfg); }
        else { tryFallback(); }   // risposta non-ok (es. 302) → fallback workers.dev
      })
      .catch(function(){ tryFallback(); }); // CORS/network error → fallback workers.dev
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
